import React, { useContext, useEffect, useState } from "react";
import CalculadoraNueva from "../../components/comunes/CalculadoraNueva";
import Footer from "../../components/comunes/Footer";
import CalculadoraPlazos from "../../components/comunes/CalculadoraPlazos";
import PaymentTable from "../../components/comunes/PaymentTable";
import ZocoPagosCalculator from "../../components/calculadoraCobros/ZocoPagosCalculator";
import { DarkModeContext } from "../../context/DarkModeContext";

// import assets
import logo from "../../assets/img/logo.png";
import logoClaro from "../../assets/img/logo-modo-oscuro.png";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ThreeDots } from "react-loader-spinner";
import { getToken } from "../../utils/auth";
import "./CalculadoraVista.css";
import "./AliadoResponsive.css";
import "react-datepicker/dist/react-datepicker.css";

// La nueva calculadora permanece oculta hasta completar su validación comercial.
// Para reactivarla, definir REACT_APP_ENABLE_CALCULADORA_COBROS=true al compilar.
const cobrosCalculatorEnabled =
  process.env.REACT_APP_ENABLE_CALCULADORA_COBROS === "true";

const CalculadoraVista = () => {
  const [activeCalculator, setActiveCalculator] = useState(
    cobrosCalculatorEnabled ? "cobros" : "plazos"
  );

  const handlePlazoClick = () => {
    setActiveCalculator("plazos");
  };

  const handleMontoClick = () => {
    setActiveCalculator("montos");
  };

    // contexto para la modalidad claro/oscuro
    const { darkMode } = useContext(DarkModeContext);

    // hooks useNavigate para la navegacion
    const navegacion = useNavigate();
  
    // funcion para recargar la pagina
    function recargarPagina() {
      window.location.reload();
    }
  
    // url de la api token
    const apiUrlToken = process.env.REACT_APP_API_TOKEN;
  

    // estado para el spinner de carga
    const [cargando, setCargando] = useState(false);

    //  consulta para verificar token
    useEffect(() => {
      const verificarToken = async () => {
        const token = getToken();
  
        if (!token) {
          manejarRespuestaNoAutorizada();
          return;
        }
        setCargando(true);
        try {
          const response = await fetch(apiUrlToken, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ Token: token }),
          });
  
          if (response.ok) {
            const data = await response.json();
  
            if (data !== 0) {
              manejarAccesoDenegado();
            }
          } else {
            if (response.status === 401) {
              manejarRespuestaNoAutorizada();
            } else {
            }
          }
        } catch (error) {}
        setCargando(false);
      };
  
      // funcion para redireccionar al home
      const redireccionar = () => {
        navegacion("/");
        recargarPagina();
      };
  
      // funcion para manera el mensaje de respuesta no autorizada
      const manejarRespuestaNoAutorizada = () => {
        sessionStorage.removeItem("token");
  
        Swal.fire({
          title: "Sesión expirada o token inválido.",
          text: "Inicie sesión nuevamente.",
          imageUrl: logo,
          imageWidth: 100,
          imageHeight: 30,
          imageAlt: "Logo",
          confirmButtonText: "Ok",
          timer: 5000,
          allowOutsideClick: true,
          customClass: {
            container: darkMode
              ? "swal2-container--dark"
              : "swal2-container--light",
            confirmButton: "my-swal-button",
          },
        }).then(redireccionar);
      };
  
      // funcion para manera el mensaje de acceso denegado
      const manejarAccesoDenegado = () => {
        Swal.fire({
          title: "Sesión expirada o token inválido.",
          text: "Inicie sesión nuevamente.",
          imageUrl: logo,
          imageWidth: 100,
          imageHeight: 30,
          imageAlt: "Logo",
          confirmButtonText: "Ok",
          timer: 5000,
          allowOutsideClick: true,
          customClass: {
            container: darkMode
              ? "swal2-container--dark"
              : "swal2-container--light",
            confirmButton: "my-swal-button",
          },
        }).then(redireccionar);
      };
  
      verificarToken();
    }, [apiUrlToken, darkMode, navegacion]);
  
    if (cargando) {
      // Muestra el spinner mientras los datos se están cargando
      return (
        <div
          className="spinner-container"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            // Fondo blanco durante la carga (en modo claro).
            background: darkMode ? undefined : "#ffffff",
          }}
        >
          <div className="">
            <div>
              <img
                className="img-fluid logo-width-spinner"
                src={darkMode ? logoClaro : logo}
                alt="logo SOCO"
              />
            </div>
            <div className="ms-3">
              <ThreeDots
                visible={true}
                height="60"
                width="60"
                color="#b4c400 "
                radius="9"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
            </div>
          </div>
        </div>
      );
    }

  return (
    <div translate="no" className={`aliado-simulador ${darkMode ? "aliado-simulador-dark" : ""}`}>
      <main className="aliado-simulador-shell">
        <header className="aliado-simulador-header">
          <div>
            <span className="aliado-simulador-kicker">CRM Aliado</span>
            <h1>Calculadora</h1>
          </div>
          <div className="aliado-simulador-date">
            {new Date().toLocaleDateString("es-AR")} | {" "}
            {new Date().toLocaleTimeString("es-AR", { hour: "2-digit", minute: "2-digit" })}
          </div>
        </header>
        <nav className="aliado-simulador-tabs" aria-label="Tipo de simulador">
          {cobrosCalculatorEnabled && (
            <button type="button" className={activeCalculator === "cobros" ? "is-active" : ""} onClick={() => setActiveCalculator("cobros")}>
              Calculadora de cobros
            </button>
          )}
          <button type="button" className={activeCalculator === "plazos" ? "is-active" : ""} onClick={handlePlazoClick}>
            Simulador de plazos
          </button>
          <button type="button" className={activeCalculator === "montos" ? "is-active" : ""} onClick={handleMontoClick}>
            Simulador de montos
          </button>
        </nav>
      {cobrosCalculatorEnabled && activeCalculator === "cobros" && <ZocoPagosCalculator />}
      {activeCalculator === "plazos" && (
        <>
          <div className="aliado-simulador-plazos">
            <CalculadoraPlazos aliadoVariant />
          </div>
          <div className="aliado-simulador-payment-table">
            <h2>Plazos de acreditación</h2>
            <PaymentTable />
          </div>
        </>
      )}
      {activeCalculator === "montos" && (
        <>
          <div className="aliado-simulador-montos">
            <CalculadoraNueva aliadoVariant />
          </div>
        </>
      )}
        <div className="aliado-simulador-footer">
          <Footer />
        </div>
      </main>
    </div>
  );
};

export default CalculadoraVista;
